import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Content, ChatWrapper, ChatComponentsView, AdViewBox } from './styles'
import ChatComponents from '@olxbr/chat-components-web'
import { getExperimentVariant, isChatVI, removeChatVI } from './util/cookie'
import myAccountDataApiCall from './api/myAccountDataApiCall'
import {
  setPageName,
  sendOnUnload,
  lurkerClickEvt,
  lurkerErrorEvt,
} from './util/lurker'

const isMsite = () => window.screen.width < 840
export default class ChatComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showChat: false,
      shouldOpenChatAutomatically: isChatVI(),
      buttonWasClicked: false,
      // Dados referentes ao carregamento das informações da conta do usuário:
      isLoading: true,
      userIsLogged: false,
      userHasValidatedPhone: false,
    }

    removeChatVI()
  }

  timeout = null

  componentDidMount() {
    setPageName('ad_detail', false)
    this.loadAccountData()
  }

  componentDidUpdate(_, prevState) {
    const { userIsLogged, userHasValidatedPhone } = this.state

    const { showChat: wasShowingChat } = prevState
    const { showChat: isShowingChat } = this.state
    if (isShowingChat && !wasShowingChat) {
      this.watchOpenChatBounce()
    }

    if (userIsLogged && userHasValidatedPhone && !this.timeout && !isMsite()) {

      const variant = getExperimentVariant('con-aut-op')
      let time = null

      if (variant === 'A') {
        time = 0
      }

      if (variant === 'B') {
        time = 5000
      }

      if (time !== null) {
        this.timeout = window.setTimeout(() => {
          this.setState({ isAutoOpen: true })
          this.openChat()
        }, time)
      }
    }
  }

  loadAccountData = () => {
    const { onReady } = this.props
    myAccountDataApiCall()
      .then(accountData => {
        this.setState({
          userIsLogged: true,
          isLoading: false,
          userHasValidatedPhone: (
            accountData.phoneVerified || accountData.configs.proAccount
          ),
        }, () => {
          this.checkIfShouldOpenChatNow()
          onReady()
        })
      })
      .catch((response) => {
        lurkerErrorEvt('mercurie_error', {
          error: 'failed_to_load_account_data',
          response_status: response ? response.status : undefined,
          response_data: response ? response.data : 'undefined',
        })
        if (response && response.status === 401) {
          this.setState({
            userIsLogged: false,
            userHasValidatedPhone: false,
            isLoading: false,
          }, this.checkIfShouldOpenChatNow)
        }
      })
  }

  checkUserAndOpenChat() {
    const { userIsLogged, userHasValidatedPhone } = this.state
    const { listId } = this.props

    if (!userIsLogged) {
      window.location = `https://conta.olx.com.br/acesso?action_type=CHAT_VI&list_id=${listId}`
      return
    }

    if (!userHasValidatedPhone) {
      window.location = `https://conta.olx.com.br/confirmacao-telefone?action_type=CHAT_VI&list_id=${listId}`
      return
    }

    this.toggleChat()
  }

  checkIfShouldOpenChatNow = () => {
    const { shouldOpenChatAutomatically, buttonWasClicked } = this.state
    if (shouldOpenChatAutomatically || buttonWasClicked) {
      this.checkUserAndOpenChat()
    }
  }

  loadDataToOpenChat = () => {
    if (this.state.isLoading) {
      lurkerClickEvt('click_chat_while_loading', 'ad_detail')
      this.setState({ buttonWasClicked: true })
      return
    }

    this.checkUserAndOpenChat()
  }

  handleButtonClick = e => {
    if (e !== undefined) {
      e.preventDefault()
    }
    this.setState({ isAutoOpen: false })
    window.clearTimeout(this.timeout)
    this.loadDataToOpenChat()
  }

  isChatOpened = () => this.state.showChat

  toggleChat = () => {
    const { showChat: prevShowChat } = this.state
    this.setState({ showChat: !prevShowChat })
  }

  watchOpenChatBounce = () => {
    this.setState({ openChatStart: new Date() })
    sendOnUnload(this.getOpenChatPayload)
  }

  getOpenChatPayload = () => {
    const { openChatStart } = this.state
    const openChatInterval = new Date() - openChatStart
    const openChatBounce = openChatInterval <= 60000 ? 1 : 0
    return { openChatInterval, openChatBounce }
  }

  closeChat = () => {
    lurkerClickEvt('close_chat', 'upr_adview_profile_component')
    this.setState({ showChat: false })
  }

  openChat = () => {
    lurkerClickEvt('open_chat', 'upr_adview_profile_component')
    this.setState({ showChat: true })
  }

  renderChatModule = () => {
    const { className, ...otherProps } = this.props
    const { showChat, userHasValidatedPhone, isAutoOpen } = this.state

    if (showChat && userHasValidatedPhone) {
      return (
        <AdViewBox id="adiew-box">
          <ChatComponentsView className={className}>
            <ChatWrapper>
              <ChatComponents
                {...otherProps}
                resource={'webAdviewProfileComponent'}
                functions={{ close: this.closeChat }}
                isAutoOpen={isAutoOpen}
              />
            </ChatWrapper>
          </ChatComponentsView>
        </AdViewBox>
      )
    }
  }

  render() {
    const { className } = this.props
    return (
      <Content className={className}>
        {this.renderChatModule()}
      </Content>
    )
  }
}

ChatComponent.propTypes = {
  listId: PropTypes.string.isRequired,
  onReady: PropTypes.func,
  ad: PropTypes.shape({
    adId: PropTypes.number,
    category: PropTypes.number,
    accountId: PropTypes.number,
    price: PropTypes.string,
    subject: PropTypes.string,
  })
}

ChatComponent.defaultProps = {
  onReady: () => { },
  ad: {
    adId: null,
    accountId: null,
    category: null,
    price: '',
    subject: '',
  }
}
